export const SET_ELE_CATEGORY1 = 'SET_ELE_CATEGORY1'
export const SET_GALLERY_IMAGE = 'SET_GALLERY_IMAGE'